module.exports = __webpack_public_path__ + "static/media/attack-2.1ab6969f.png";